import { render } from "./CartelDeInformacionLink.vue?vue&type=template&id=48bcfcae&scoped=true"
import script from "./CartelDeInformacionLink.vue?vue&type=script&lang=js"
export * from "./CartelDeInformacionLink.vue?vue&type=script&lang=js"

import "./CartelDeInformacionLink.vue?vue&type=style&index=0&id=48bcfcae&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bcfcae"]])

export default __exports__